module.exports = __webpack_public_path__ + "img/after-effects-cc.71e2f4db.svg";